import webContextProvider from "../../../../../providers/webContextProvider";

const getSiteContent1 = () => webContextProvider().floor;

export default getSiteContent1;
